module.exports = __webpack_public_path__ + "static/media/area_1_orange_swish.1c1d24b3.svg";